import { FC, useState } from "react";
import { Button } from "../common/ButtonV2/Button";
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/24/solid";
import { FormSection } from "./types";
import { Field } from "./FormField";
import { FieldErrors, UseFormRegister } from "react-hook-form";

type FormBlockProps = {
  formSection: FormSection;
  register: UseFormRegister<any>;
  errors: FieldErrors;
  namePrefix?: string;
  variant?: "default" | "compact";
  disabled?: boolean;
};

export const FormBlock: FC<FormBlockProps> = ({
  formSection,
  register,
  errors,
  namePrefix,
  variant = "default",
  disabled
}) => {
  const { title, description, required, formFields } = formSection;
  const [open, setOpen] = useState(required);
  return (
    <div
      className={`grid grid-cols-6  ${
        variant === "compact" ? "" : "gap-4 lg:gap-10"
      }  py-6 px-8 w-full bg-white rounded-lg shadow`}
    >
      <div
        className={`col-span-6 ${
          open
            ? `${variant === "compact" ? "" : "lg:col-span-2"}`
            : `flex flex-col justify-between md:flex-row md:gap-4  `
        }`}
      >
        <div className={`${variant === "compact" ? "" : "shrink"} mb-2`}>
          <h2 className="reveal-font-title text-gray-800">{title}</h2>
          {!disabled && description && (
            <p className="reveal-font-body text-sm text-gray-500">
              {description}
            </p>
          )}
        </div>
        {!required && (
          <Button
            variant="text"
            Icon={open ? MinusSmallIcon : PlusSmallIcon}
            color="underdots"
            size="small"
            mode="light"
            onClick={() => setOpen(!open)}
            className="px-0 w-fit whitespace-nowrap	"
          >
            {open ? "Hide" : "Show fields"}
          </Button>
        )}
      </div>

      {open && (
        <div className="col-span-6 lg:col-span-4">
          {formFields.map((field) => {
            const fullName = namePrefix ? namePrefix + field.name : field.name;
            return (
              <Field
                key={fullName}
                formField={field}
                registerReturnProps={register(fullName, {
                  required: field.required
                })}
                errors={errors}
                disabled={disabled}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};
